<template>
  <div class="rounded-lg bg-[#EEE4FD] p-12 text-left">
    <RevTag :label="tagLabel" variant="alternate" />
    <h3 class="body-1-bold">{{ title }}</h3>
    <div class="caption pt-8">{{ subtitle }}</div>
  </div>
</template>

<script lang="ts" setup>
import { RevTag } from '@ds/components/Tag'

defineProps<{
  tagLabel: string
  title: string
  subtitle: string
}>()
</script>
